<ng-container *ngIf="{
    value: false
  } as isLoaded">
  <div class="{{ innerClass }} pos-rel">
    <ion-img
      class="{{ innerClass }}"
      src="{{ src }}"
      (ionImgDidLoad)="isLoaded.value = true">
    </ion-img>
    <ion-skeleton-text
      *ngIf="isLoaded.value === false"
      animated
      class="pos-abs inset-0 my-0">
    </ion-skeleton-text>
  </div>
</ng-container>
